module.exports = "<div class=\"close\">\n  <mat-icon (click)=\"onclick.emit()\">close</mat-icon>\n</div>\n"